import {createSvgIcon} from '../create-svg-icon';

export const LabelImportantIcon = createSvgIcon(
  <path d="M4 18.99h11c.67 0 1.27-.32 1.63-.83L21 12l-4.37-6.16C16.27 5.33 15.67 5 15 5H4l5 7-5 6.99z" />
, 'LabelImportantOutlined');
